import { render, staticRenderFns } from "./BaseNavbar.vue?vue&type=template&id=629d6be6"
import script from "./BaseNavbar.vue?vue&type=script&lang=js"
export * from "./BaseNavbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports